import React from "react";
import { Link, useLocation } from "react-router-dom";

// react-bootstrap components
import { Navbar, Container } from "react-bootstrap";
import { properties } from "../../config/ClientConfigurations";
import LanguageSwitcher from "components/LanguageSwitcher/LanguageSwitcher";

function HipposAuthNavbar() {
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  return (
    <>
      <Navbar className="position-absolute w-100" expand="lg" variant={collapseOpen ? "white" : "transparent"}>
        <Container>
          <div className="navbar-wrapper">
            <Navbar.Brand onClick={(e) => e.preventDefault()}>
              <span className="d-none d-md-block">{properties.appName}</span>
              <span className="d-block d-md-none">{properties.appName}</span>
            </Navbar.Brand>
          </div>
          <LanguageSwitcher className="login-language-dropdown" />
        </Container>
      </Navbar>
    </>
  );
}

export default HipposAuthNavbar;
